import DataTable from "react-data-table-component";

const CompactDataTable = ({ columns, data,onRowClicked,pagination }) => {
  const customStyles = {
    table: {
      style: {
        border: "1px solid #ddd", // Light border around the table
      },
    },
    headRow: {
      style: {
        backgroundColor: "#f8f9fa",
        fontWeight: "bold",
        borderBottom: "1px solid #ddd",
      },
    },
    rows: {
      style: {
        minHeight: "40px", // Compact row height
        borderBottom: "1px solid #eee",
      },
    },
  };

  return (
    <DataTable
      columns={columns}
      data={data}
      onRowClicked={onRowClicked}
      customStyles={customStyles}
      pagination={pagination}
      paginationPerPage={5} // Number of rows per page
      paginationRowsPerPageOptions={[5, 10, 20]} // Options for rows per page
      highlightOnHover
      dense // Compact mode
    />
  );
};

export default CompactDataTable;
